module.exports = {};



// WEBPACK FOOTER //
// ./techpad-upgrade/~/core-js/modules/_iterators.js